type Props = {
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
    id?: string | number;
};

export function CaretIcon({ width = 5, height = 8, className, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 5 8"
            fill="none"
            className={className}
            style={style}
        >
            <path d="M0.75 6.75L3.75 3.75L0.75 0.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default CaretIcon;
